import * as types from '../constants/itSalesConstants';

const initialState = {
  partners: [],
  licenses: [],
  oemPartners: [],
  oemUsers: [],
  loading: false,
  formLoading: false,
  error: null,
  success: false,
  passwordResetStatus: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

const itSalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ITSALES_PARTNERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_ITSALES_PARTNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || action.payload.partners || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case types.GET_ITSALES_PARTNERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        partners: [],
      };

    case types.ADD_ITSALES_PARTNER_REQUEST:
      return {
        ...state,
        formLoading: true,
        error: null,
        success: false,
      };

    case types.ADD_ITSALES_PARTNER_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        error: null,
      };

    case types.ADD_ITSALES_PARTNER_FAILURE:
      return {
        ...state,
        formLoading: false,
        error: action.payload,
        success: false,
      };

    case types.EDIT_ITSALES_PARTNER_REQUEST:
      return {
        ...state,
        formLoading: true,
        error: null,
        success: false,
      };

    case types.EDIT_ITSALES_PARTNER_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        error: null,
      };

    case types.EDIT_ITSALES_PARTNER_FAILURE:
      return {
        ...state,
        formLoading: false,
        error: action.payload,
        success: false,
      };

    case types.DELETE_ITSALES_PARTNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DELETE_ITSALES_PARTNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.DELETE_ITSALES_PARTNER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.CHANGE_ITSALES_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CHANGE_ITSALES_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.CHANGE_ITSALES_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.RESET_ITSALES_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.RESET_ITSALES_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        passwordResetStatus: action.payload?.status || 200,
        error: null,
      };

    case types.RESET_ITSALES_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.GET_ITSALES_LICENSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_ITSALES_LICENSES_SUCCESS:
      return {
        ...state,
        loading: false,
        licenses: action.payload.response || action.payload.licenses || action.payload || [],
        error: null,
      };

    case types.GET_ITSALES_LICENSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.GET_ITSALES_PARTNER_OEM_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_ITSALES_PARTNER_OEM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        oemPartners: action.payload.response || action.payload.oemPartners || action.payload || [],
        error: null,
      };

    case types.GET_ITSALES_PARTNER_OEM_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.GET_ITSALES_PARTNER_OEM_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_ITSALES_PARTNER_OEM_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        oemUsers: action.payload.response || action.payload.oemUsers || action.payload || [],
        error: null,
      };

    case types.GET_ITSALES_PARTNER_OEM_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'RESET_ITSALES_SUCCESS':
      return {
        ...state,
        success: false,
        passwordResetStatus: null,
      };

    case types.RESEND_ITSALES_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.RESEND_ITSALES_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };

    case types.RESEND_ITSALES_VERIFICATION_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default itSalesReducer;